module.exports = __webpack_public_path__ + "img/sv5.6e0dfc2c.svg";